import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
}

export const ArchiveEventSlice = createSlice({
  name: 'ArchiveEvent',
  initialState,
  reducers: {
    ArchiveEvent_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    ArchiveEvent_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    ArchiveEvent_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_ArchiveEvent_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {ArchiveEvent_request, ArchiveEvent_success, ArchiveEvent_failure, Clear_ArchiveEvent_Check } = ArchiveEventSlice.actions

export default ArchiveEventSlice.reducer